export type Group = "home" | "grandma" | "human" | "pet" | "vehicle";
export type Crop = { x: number; y: number; width: number; height: number };
export type Character = {
  id: string;
  name: string;
  group: Group;
  sheet: 1 | 2;
  pos: string;
  role: string;
  crop: Crop;
};
export const sheetDimensions = {
  1: { width: 1448, height: 1086 },
  2: { width: 1122, height: 1402 },
} as const;
const cropMap: Record<string, Crop> = {
  "dai-lup": { x: 40, y: 105, width: 140, height: 350 },
  "dai-fa": { x: 185, y: 95, width: 170, height: 365 },
  grandma: { x: 365, y: 115, width: 150, height: 345 },
  bibi: { x: 575, y: 65, width: 175, height: 265 },
  "big-eye": { x: 770, y: 70, width: 150, height: 265 },
  fafa: { x: 930, y: 90, width: 155, height: 245 },
  "do-nga": { x: 1090, y: 65, width: 165, height: 270 },
  chun: { x: 1250, y: 120, width: 160, height: 220 },
  lamlam: { x: 580, y: 390, width: 135, height: 180 },
  dukduk: { x: 740, y: 390, width: 135, height: 180 },
  fake: { x: 900, y: 390, width: 135, height: 180 },
  bow: { x: 1045, y: 390, width: 135, height: 180 },
  ppi: { x: 1220, y: 390, width: 145, height: 180 },
  "wong-choi": { x: 90, y: 720, width: 330, height: 250 },
  "car-one": { x: 630, y: 720, width: 325, height: 225 },
  "car-horse": { x: 1035, y: 715, width: 300, height: 235 },
  bean: { x: 35, y: 45, width: 170, height: 190 },
  lion: { x: 250, y: 45, width: 180, height: 195 },
  bo: { x: 470, y: 45, width: 185, height: 195 },
  "tin-king": { x: 690, y: 45, width: 190, height: 195 },
  "big-kin": { x: 910, y: 45, width: 180, height: 195 },
  "mid-kin": { x: 35, y: 345, width: 180, height: 150 },
  "small-kin": { x: 255, y: 345, width: 175, height: 150 },
  "a-tin": { x: 475, y: 345, width: 180, height: 150 },
  kuk: { x: 695, y: 345, width: 180, height: 150 },
  "big-face": { x: 915, y: 345, width: 180, height: 150 },
  frog: { x: 35, y: 610, width: 180, height: 150 },
  abi: { x: 255, y: 610, width: 180, height: 150 },
  prof: { x: 475, y: 610, width: 180, height: 150 },
  fish: { x: 695, y: 610, width: 180, height: 150 },
};
export const characters: Character[] = [
  ["dai-lup", "大粒", "human", 1, "8% 24%", "家庭核心／玩家"],
  ["dai-fa", "大花", "human", 1, "19% 24%", "一次搬兩件"],
  ["grandma", "婆婆", "human", 1, "31% 24%", "任務與獎勵"],
  ["bibi", "比比", "home", 1, "45% 20%", "教學大佬"],
  ["big-eye", "大眼", "home", 1, "57% 20%", "發現隱藏物"],
  ["fafa", "法法", "home", 1, "68% 20%", "排列加分"],
  ["do-nga", "多牙", "home", 1, "80% 20%", "跑跑教練"],
  ["chun", "純純", "home", 1, "92% 20%", "保住跌漏物"],
  ["lamlam", "攬攬＋細粒Ppi", "home", 1, "45% 48%", "走失救援"],
  ["dukduk", "篤篤", "home", 1, "57% 48%", "指出錯誤"],
  ["fake", "老返", "home", 1, "68% 48%", "路線預覽"],
  ["bow", "二佬Bow", "home", 1, "80% 48%", "Checklist"],
  ["ppi", "大佬Ppi", "home", 1, "92% 48%", "冷靜值回復"],
  ["wong-choi", "旺財", "pet", 1, "18% 80%", "門口救援"],
  ["car-one", "一仔", "vehicle", 1, "54% 80%", "穩定路線"],
  ["car-horse", "馬仔", "vehicle", 1, "81% 80%", "極速路線"],
  ["bean", "阿豆", "grandma", 2, "8% 12%", "圖案記憶"],
  ["lion", "傻獅", "grandma", 2, "27% 12%", "安撫救援"],
  ["bo", "波波／阿波", "grandma", 2, "48% 12%", "婆婆屋企交接"],
  ["tin-king", "甸王", "grandma", 2, "68% 12%", "收納"],
  ["big-kin", "大健", "grandma", 2, "89% 12%", "搬大件"],
  ["mid-kin", "中健", "grandma", 2, "9% 37%", "平衡次序"],
  ["small-kin", "細健", "grandma", 2, "29% 37%", "找小物"],
  ["a-tin", "阿甸", "grandma", 2, "49% 37%", "門口等候"],
  ["kuk", "曲曲", "grandma", 2, "69% 37%", "節奏"],
  ["big-face", "大面", "grandma", 2, "90% 37%", "表情提示"],
  ["frog", "阿蛙", "grandma", 2, "9% 61%", "安靜房"],
  ["abi", "阿bi", "grandma", 2, "30% 61%", "易碎物"],
  ["prof", "老畢", "grandma", 2, "50% 61%", "知識提示"],
  ["fish", "魚魚", "grandma", 2, "70% 61%", "浴室助手"],
].map(
  ([id, name, group, sheet, pos, role]) =>
    ({
      id,
      name,
      group,
      sheet,
      pos,
      role,
      crop: cropMap[id as string],
    }) as Character,
);
export const byId = (id: string) => characters.find((c) => c.id === id)!;
export const helperIds = [
  "bibi",
  "big-eye",
  "fafa",
  "do-nga",
  "chun",
  "lamlam",
] as const;
export const driverIds = [
  "dai-lup",
  "dai-fa",
  "bibi",
  "big-eye",
  "fafa",
  "do-nga",
] as const;
export const opponentIds = ["bibi", "big-eye", "fafa", "do-nga"] as const;
export const rooms = [
  { id: "living", name: "客廳", items: ["垃圾袋", "電話"] },
  { id: "kitchen", name: "廚房", items: ["水樽", "環保袋"] },
  { id: "bathroom", name: "浴室", items: ["毛巾", "紙巾"] },
  { id: "bedroom", name: "睡房", items: ["鎖匙", "外套"] },
];

export const daiLupSkins: Character[] = [
  {
    id: "dai-lup-look-2",
    name: "大粒・形象2",
    group: "human",
    sheet: 2,
    pos: "91% 61%",
    role: "藍色外套造型",
    crop: { x: 936, y: 605, width: 170, height: 190 },
  },
  {
    id: "dai-lup-look-3",
    name: "大粒・形象3",
    group: "human",
    sheet: 2,
    pos: "37% 84%",
    role: "輕鬆微笑造型",
    crop: { x: 320, y: 875, width: 205, height: 385 },
  },
  {
    id: "dai-lup-look-4",
    name: "大粒・形象4",
    group: "human",
    sheet: 2,
    pos: "64% 84%",
    role: "活力姿勢造型",
    crop: { x: 602, y: 875, width: 205, height: 385 },
  },
];

export const unlockOrder = characters.map((character) => character.id);
